export const NEED_TYPES = [
  "Quelques heures", "Une demi-journée", "Une journée", "Plusieurs jours",
  "Un besoin récurrent", "Un remplacement temporaire", "Une mission administrative",
  "Un projet", "Je ne sais pas encore",
];

export const CONTACT_METHODS = ["E-mail", "Téléphone", "Peu importe"];

export const MESSAGE_CATEGORIES = [
  "Question générale", "Planning", "Mission", "Facturation", "Service", "Projet", "Urgent administratif",
];

export const CANTONS = ["GE", "VD", "VS", "NE", "FR", "JU", "BE", "ZH", "TI", "Autre"];

export const REQUEST_STATUSES = [
  "Nouveau prospect", "Demande reçue", "En attente", "À analyser", "En cours d'attribution",
  "Attribuée", "Confirmée", "En cours", "Terminée", "Refusée", "Annulée",
];

export const LEAD_STATUSES = ["Nouveau", "À contacter", "Contacté", "Qualifié", "Compte créé", "Client", "Perdu"];

export const ALL_ROLES = [
  { key: "doctor", label: "Médecin / Client" },
  { key: "secretary", label: "Secrétaire" },
  { key: "admin", label: "Administrateur" },
  { key: "super_admin", label: "Super administrateur" },
];

export const CAP = {
  available: { label: "Disponible", badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", cell: "border-emerald-200 bg-emerald-50/50 hover:bg-emerald-100/60" },
  limited: { label: "Disponibilité limitée", badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500", cell: "border-amber-200 bg-amber-50/50 hover:bg-amber-100/60" },
  full: { label: "Complet", badge: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500", cell: "border-slate-200 bg-slate-100 text-slate-400" },
};

export const WEEKDAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
